import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'referenceText' })
export class ReferenceTextPipe implements PipeTransform {
	constructor(private sanitizer: DomSanitizer) {}

	transform(value: string | null | undefined, maxLen?: number | null): SafeHtml {
		if (value == null || typeof value !== 'string') {
			return this.sanitizer.bypassSecurityTrustHtml('');
		}
		const brToNewline = value.replace(/<br\s*\/?>/gi, '\n');
		let plain = brToNewline
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');
		if (maxLen != null && maxLen > 0) {
			const flat = plain.replace(/\r\n|\r|\n/g, ' ').replace(/\s+/g, ' ').trim();
			if (flat.length > maxLen) {
				plain = flat.slice(0, maxLen - 1).trimEnd() + '…';
			} else {
				plain = flat;
			}
			return this.sanitizer.bypassSecurityTrustHtml(plain);
		}
		const withBreaks = plain.replace(/\r\n|\r|\n/g, '<br />');
		return this.sanitizer.bypassSecurityTrustHtml(withBreaks);
	}
}
